import React, {useContext, useEffect} from "react";
import "./App.css";
import {Navigate, Route, Routes} from "react-router";
import {LandingPage} from "./views/LandingPage";
import {useLocation} from "react-router-dom";
import Imprint from "./views/Imprint";
import AuthErrorPage from "./views/AuthErrorPage";
import {ModalContext} from "@spg/component_library";
import {SnackbarContext} from "./reusables/SnackbarProvider";
import {KeycloakContext} from "./views/utility/KeycloakProvider";

function App() {
  const {keycloak, initialized, authenticated} = useContext(KeycloakContext);
  const pathname = useLocation().pathname;
  const modalContext = useContext(ModalContext);
  const snackbarContext = useContext(SnackbarContext);

  const removeOverlaidMessages = () => {
    snackbarContext.removeAllSnackbars();
    modalContext.hideModal();
  };

  useEffect(() => {
    if (pathname == "/imprint") removeOverlaidMessages();
  }, [pathname]);

  if (pathname == "/imprint") return <Imprint />;

  if (!initialized || !authenticated)
    return (
      <AuthErrorPage
        reason="unauthenticated"
        afterTimeout={removeOverlaidMessages}
      />
    );

  if (
    !["DM Administration", "DM Mitglied"].some((role) =>
      keycloak.hasResourceRole(role),
    )
  )
    return (
      <AuthErrorPage
        reason="unauthorized"
        afterTimeout={removeOverlaidMessages}
      />
    );

  return (
    <Routes>
      <Route path="/*" element={<LandingPage />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
